import * as XLSX from "xlsx";
import { GENERAL_URL_API } from "../../urls";

const postForm = async (url, fields) => {
  const fd = new FormData();
  Object.entries(fields).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    fd.append(key, value);
  });

  const res = await fetch(url, {
    method: "POST",
    credentials: "include",
    body: fd,
  });
  if (!res.ok) throw new Error(`Error de conexión (${res.status})`);

  const json = await res.json();
  if (json?.status !== 1) throw new Error(json?.info || "No se pudo completar la acción");
  return json;
};

const comoLista = (json) => (Array.isArray(json?.data) ? json.data : []);

export const fetchCursosPlanLector = async () =>
  comoLista(await postForm(`${GENERAL_URL_API}/Cursos/verCursos.php`, {}));

export const fetchLibrosSede = async (sede) =>
  comoLista(await postForm(`${GENERAL_URL_API}/paquetes/verLibrosSede`, { sede }));

export const fetchLibrosCurso = async (idCurso) =>
  comoLista(await postForm(`${GENERAL_URL_API}/paquetes/verLibrosCurso.php`, { idCurso }));

/**
 * El endpoint masivo solo inserta. `agregarLibrosCurso` reemplaza la lista:
 * cualquier libro que no viaje en `idLibros` se elimina del curso.
 */
const excelLibrosCurso = (idCurso, idLibros) => {
  const hoja = XLSX.utils.aoa_to_sheet([
    ["idCurso", "idLibro"],
    ...idLibros.map((idLibro) => [String(idCurso), String(idLibro)]),
  ]);
  const libro = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(libro, hoja, "Libros");
  const buffer = XLSX.write(libro, { bookType: "xlsx", type: "array" });
  return new File([buffer], "libros-curso.xlsx", {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
};

export const agregarLibrosACurso = async ({ idCurso, idLibros }) => {
  const ids = [...new Set(idLibros.map((id) => String(id).trim()).filter(Boolean))];
  if (!ids.length) throw new Error("No hay libros para agregar");

  const fd = new FormData();
  fd.append("books", excelLibrosCurso(idCurso, ids));
  const res = await fetch(`${GENERAL_URL_API}/paquetes/agregarLibrosCursoMasivo`, {
    method: "POST",
    credentials: "include",
    body: fd,
  });
  if (!res.ok) throw new Error(`Error de conexión (${res.status})`);

  const data = await res.json();
  if (data?.status !== 1) throw new Error(data?.info || "No se pudieron agregar los libros");

  const summary = data.data?.summary;
  const agregados = summary ? summary.total - summary.warnings : ids.length;
  if (!agregados) {
    throw new Error(data.data?.warnings?.[0] || data.info || "No se agregó ningún libro");
  }
  return data.info;
};

/** Deja en el curso únicamente `idLibrosRestantes`. Una lista vacía lo deja sin libros. */
export const quitarLibrosCurso = async ({ idCurso, idLibrosRestantes }) => {
  const json = await postForm(`${GENERAL_URL_API}/paquetes/agregarLibrosCurso`, {
    idCurso,
    idLibros: idLibrosRestantes.join(","),
  });
  return json.info;
};
